import { render, staticRenderFns } from "./NoiseSupression.vue?vue&type=template&id=a202655e&scoped=true"
import script from "./NoiseSupression.vue?vue&type=script&lang=js"
export * from "./NoiseSupression.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a202655e",
  null
  
)

export default component.exports